
const resultsRoutes = [
    {
      path: '/result/use-client',
      name: 'resultUseClient',
      component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/result/use-client.vue'),
      meta: {
        title: "请使用大工程师",
      },
    },
  ];
  
  export default resultsRoutes;
  